$(document).ready(function() {

  var prd_handle = $(".product-single__title").data("handle");
console.log("prd_handle",prd_handle)
    $(".additional-color-grid").each(function(index, prd) {
        $(this).find('li').each(function(ind, prdli) {
            console.log($(this).children().attr("data-product-handle"))
            var product_li = $(this).children().attr("data-product-handle");
            if (prd_handle == product_li) {
                console.log(product_li, "product_li_in");
                $(this).addClass("cl_active");

            }
        });
    });
 });
// var variant_select = $('select.variant_prd_dropdown option:selected').val();
// console.log(variant_select,"variant_select")
// var PRODUCT_variants = $('#product_variants_2').length ? JSON.parse($('#product_variants_2').html()) : null;
// console.log(PRODUCT_variants)
// var prd_var = PRODUCT_variants;
//       prd_var = prd_var.filter(function(variant) {
//         return variant.variant_title.includes(variant_select);
//       });
// console.log("after",prd_var.length)
// if(prd_var.length == 0){
//     $(".grid-product__link_3").css({"pointer-events": "none"});
// }


